import {ReactNode, useEffect, useRef, useState} from "react";
import styled from "@emotion/styled";
import {VariableSizeList as Grid} from "react-window"

export type Column = {
    key: string,
    label: string,
    synthetic?: false,
    render?: (row: any) => ReactNode
    export?: (row: any) => any;
    convert?: (v: any | undefined) => any
} | {
    key: string;
    label: string;
    synthetic: true;
    render: (row: any) => ReactNode;
    export?: (row: any) => any;
    convert?: (v: any | undefined) => any
}

type DataGridProps = {
    data: Array<any>,
    onRowDoubleClick?: (row: any) => void,
    onSelect?: (row: any) => void,
    columns: Column[],
    generateBackgroundColor?: (row: any) => string,
}

const TableHeader = styled.div`
    background-color: var(--gray-lightest);

    border-bottom: 2px solid var(--gray-lighter);
    font-weight: 400;
    white-space: nowrap;
    text-align: left;
    line-height: 1.25;
    vertical-align: middle;
    color: var(--gray-darkest);
    display: flex;


    div {
        padding: 7px 12px;
        font-size: 1.6rem;
    }

`

const TableRow = styled.div`
    display: flex;

    
    &:hover {
        background: var(--color-highlight-lightest);
    }


    &.selected {
        background: var(--color-highlight) !important;
    }




`

const iter = (x: number): Array<number> => {
    const a = []
    for (let i = 0; i < x; i++) {
        a.push(i)
    }
    return a
}


export const DataGrid = ({data, onRowDoubleClick, onSelect, columns, ...props}: DataGridProps) => {

    const container = useRef<HTMLDivElement>(null)
    const [width, setWidth] = useState(0)
    const [columnWidths, setColumnsWidths] = useState<Array<number>>([])
    const [selectedIndex, setSelectedIndex] = useState<number>(-1)
    const clickCount = useRef(0)
    const singleClickTimer = useRef<NodeJS.Timeout | undefined>(undefined)

    let generateBackgroundColor = (_: any) => "white"
    if (props.generateBackgroundColor) {
        generateBackgroundColor = props.generateBackgroundColor
    }

    useEffect(() => {
        const a = () => {
            const totalWidth = container.current?.offsetWidth || 1

            setColumnsWidths(iter(columns.length).map(() => totalWidth / columns.length))
            setWidth(totalWidth)
        }

        if (container.current !== null) {
            new ResizeObserver(a).observe(container.current)
        }
    }, [container, columns])

    useEffect(() => {
        if (selectedIndex > -1 && onSelect) {
            onSelect(data[selectedIndex])
        }
    }, [selectedIndex, onSelect]);


    const Cell = ({index, style}: any) => {
        return (
            <TableRow style={{...style, backgroundColor: generateBackgroundColor(data[index])}}
                      className={index === selectedIndex ? "selected" : ""}
                      onClick={(event) => {
                          event.preventDefault();

                          clickCount.current++;

                          if (clickCount.current === 1) {
                              singleClickTimer.current = setTimeout(() => {
                                  clickCount.current = 0;

                                  //Single Click
                                  if (selectedIndex === index) {
                                      setSelectedIndex(-1)
                                  } else {
                                      setSelectedIndex(index)
                                  }
                              }, 200)
                          } else if (clickCount.current === 2) {
                              clearInterval(singleClickTimer.current)
                              clickCount.current = 0
                              window?.getSelection()?.empty()
                              if (onRowDoubleClick) {
                                  onRowDoubleClick(data[index])
                              }
                          }


                      }}>
                {columns.map((column, i) => {
                        const isSynthetic = column.synthetic
                    const hasConverter = !!column.convert

                        return <div style={{width: columnWidths[i], padding: "7px 12px"}}
                                    key={column.key + index}>
                            {isSynthetic ? column.render(data[index]) :
                                hasConverter ? column.convert!(data[index][column.key]) : data[index][column.key]}
                        </div>
                    }
                )}
            </TableRow>
        )
    };


    return <div ref={container} style={{minWidth: 100, minHeight: 100}}>
        {width !== 0 &&
            <>
                <TableHeader>
                    {columns.map((column, i) => <div style={{width: columnWidths[i], textOverflow: "ellipsis", overflow: "clip"}}
                                                     key={column.key}>{column.label}</div>)}
                </TableHeader>
                <Grid
                    style={{background: "white"}}
                    itemCount={data.length}
                    height={500}
                    itemSize={_ => 32}
                    width={width}>
                    {Cell}
                </Grid>
            </>}
    </div>
}